import { Spin } from "antd";
import React, { useEffect, useState } from "react";
import { FormNewProject } from "./components/FormNewProject";
import { createRequestNewProject, getRequestDataNewProject } from "../../../config";
import CardDetailProject from "../../../components/Card/CardDetailProject";
import { MessageAnt } from "../../../redux/slices/ui/uiAction";
import { MessageType } from "../../../types/messageType";
import "./project.css";

export const PageNewProject = () => {
    const [loading, setLoading] = useState(true);
    const [projects, setProjects] = useState([]);

    useEffect(() => {
        setLoading(true);
        getRequestDataNewProject().then(({ payload }) => {
            const data = payload.filter((click) => {
                const name = click.name.toLowerCase();
                return !name.startsWith("inmersys");
            });
            setProjects(data);
            setLoading(false);
        });
    }, []);

    const onFinish = (values) => {
        setLoading(true);
        createRequestNewProject(values)
            .then(({ status, msg }) => {
                if (status > 0) {
                    MessageAnt(MessageType.warning, `${msg}`);
                } else {
                    MessageAnt(MessageType.success, `Se creo el proyecto`);
                }
            })
            .catch((error) => {
                console.log("error", error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    if (loading) {
        return (
            <>
                <div style={{ height: "100vh" }} className="flex-center">
                    <Spin size="large" />
                </div>
            </>
        );
    } else {
        return (
            <div className="lg:p-12 p-4 w-full h-full max-w-[1000px] flex flex-col gap-6 mx-auto">
                <CardDetailProject title="Agregar un nuevo proyecto">
                    <FormNewProject projects={projects} onFinish={onFinish} />
                </CardDetailProject>
            </div>
        );
    }
};
